import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/middleware'
import { RolesAndPermissionsPage } from '@/features/access-control/roles-and-permissions-page'

function MembersAccessRoute() {
  return <RolesAndPermissionsPage defaultTab='members' />
}

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/members'
)({
  beforeLoad: async () => {
    await requireAuth()
  },
  component: MembersAccessRoute,
})
